// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_Payors($patient_id: numeric!) {
  vaxiom_patients_by_pk(id: $patient_id) {
    id
    _id
    payment_accounts {
      payment_account {
        account_type
      }
      payor {
        _id
        id
        first_name
        greeting
        last_name
      }
      insurance_company {
        id
        carrier_name
      }
      insurance_plan {
        id
        number
      }
      insured_id
      payment_account_id
    }
  }
}

`